import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { DatepickerDefaults, DatepickerDefaultsInterface } from "./defaults.service";
import { USER_DEFAULTS } from "./tokens";

export function provideUiKitDatepicker(userDefaults: DatepickerDefaultsInterface = {}): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: USER_DEFAULTS,
            useValue: userDefaults
        },
        {
            provide: DatepickerDefaults,
            useFactory: (userDefaults: DatepickerDefaultsInterface): DatepickerDefaults => {
                const defaults: DatepickerDefaults = new DatepickerDefaults();
                return { ...defaults, ...userDefaults } as DatepickerDefaults;
            },
            deps: [USER_DEFAULTS]
        }
    ]);
}
